import { Link } from 'react-router-dom';

/**
 * Terms of Service. Plain-language usage terms for a free daily word game.
 * Wording is a starting draft — have it reviewed for your jurisdiction
 * (especially the governing-law line) before relying on it.
 */
export default function Terms() {
  return (
    <section data-testid="page-terms" className="prose-stone mx-auto max-w-prose">
      <h1 className="text-2xl font-bold text-stone-900">Terms of Service</h1>
      <p className="mt-1 text-sm text-stone-500">Last updated 12 June 2026</p>

      <p className="mt-4 text-stone-700">
        These terms apply to your use of Scrabble Daily. By creating an account or playing, you
        agree to them. If you do not agree, please don’t use the service.
      </p>

      <h2 className="mt-6 text-lg font-bold text-stone-900">The service</h2>
      <p className="mt-2 text-stone-700">
        Scrabble Daily is a free daily word game. We may change, suspend, or discontinue any part of
        it at any time. We aim for a fresh set of puzzles each day but don’t guarantee uninterrupted
        availability.
      </p>

      <h2 className="mt-6 text-lg font-bold text-stone-900">Your account</h2>
      <p className="mt-2 text-stone-700">
        You’re responsible for keeping your sign-in details secure and for activity on your account.
        Provide an email address you control. You can delete your account at any time from{' '}
        <Link to="/settings" className="font-semibold text-emerald-700 underline">
          Settings
        </Link>
        .
      </p>

      <h2 className="mt-6 text-lg font-bold text-stone-900">Acceptable use</h2>
      <p className="mt-2 text-stone-700">
        Play fairly. Don’t cheat, automate play, attempt to break or overload the service, abuse
        other players, or choose a leaderboard name that is offensive or impersonates someone. We
        may suspend or remove accounts that break these rules.
      </p>

      <h2 className="mt-6 text-lg font-bold text-stone-900">Intellectual property</h2>
      <p className="mt-2 text-stone-700">
        “Scrabble” is a trademark of its respective owners; Scrabble Daily is an independent game
        and is not affiliated with or endorsed by them. The site’s content and code are ours or our
        licensors’ and are provided for your personal, non-commercial use.
      </p>

      <h2 className="mt-6 text-lg font-bold text-stone-900">No warranty &amp; liability</h2>
      <p className="mt-2 text-stone-700">
        The service is provided “as is”, without warranties of any kind. To the extent permitted by
        law, we are not liable for any indirect or incidental damages arising from your use of it.
      </p>

      <h2 className="mt-6 text-lg font-bold text-stone-900">Changes &amp; contact</h2>
      <p className="mt-2 text-stone-700">
        We may update these terms; we’ll revise the date above when we do, and continued use means
        you accept the changes. Questions? Email{' '}
        <a href="mailto:waltersn63@gmail.com" className="font-semibold text-emerald-700 underline">
          waltersn63@gmail.com
        </a>
        .
      </p>

      <p className="mt-6 text-sm text-stone-500">
        See also our{' '}
        <Link to="/privacy" className="font-semibold text-emerald-700 underline">
          Privacy Policy
        </Link>
        .
      </p>
    </section>
  );
}
